import { arrowTags } from '../const/_sanitize'
import AttrsCheck from '../service/_attrsCheck'
import parse5 from 'parse5'
import { isObject, objectToGet } from '../functions/index'

/**
 * SanitizeJs // jsタグの無効化
 *
 * @returns {undefined}
 */

class SanitizeJs {
  /**
   * start // サニタイズを実行
   *
   * @param {object} data parse5
   *
   * @return {object}
   */
  start(data) {
    // defaultのコンフィグにマージ
    return this.convert(data)
  }

  /**
   * htmlToData // htmlをparse5のオブジェクトに変換する
   *
   * @param {string} html
   *
   * @return {object} parse5
   */
  htmlToData(html) {
    return parse5.parseFragment(html)
  }

  /**
   * dataToHtml // オブジェクトをhtmlに変換する
   *
   * @param {object} data // parse5
   *
   * @return {string} html
   */
  dataToHtml(data) {
    return parse5.serialize(data)
  }

  /**
   * convert // 値を変換する
   *
   * @param {any} val
   *
   * @return {object}
   */
  convert(val) {
    if (isObject(val)) return this.object(val)
    if (Array.isArray(val)) return this.array(val)
    return val
  }

  /**
   * object // オブジェクトデータを処理
   *
   * @param {object} object
   *
   * @return {object}
   */
  object(object) {
    if (!isObject(object)) return object
    // 解析ツールのオブジェクトを除外
    if (this.get(object, 'tagName', null) === null) {
      const child = object.childNodes
      if (child) object.childNodes = this.convert(child)
      return object
    }

    // タグ名を取得
    const name = this.get(object, 'tagName')

    // タグの許可一覧からタグ名の設定値を取得
    const config = arrowTags.find(val => val.tag === name)

    // 許可するタグに入っていない場合削除
    const isArrowTag = Boolean(config)
    if (!isArrowTag) return {}

    // 属性値を削除
    const attrs = this.get(object, 'attrs')
    if (attrs) {
      const attrsAfter = this.attrs(attrs, config)
      object.attrs = attrsAfter

      const src = attrsAfter.find(item => item.name === 'src')
      const href = attrsAfter.find(item => item.name === 'href')

      // hrefもしくはsrcがからの場合 タグごと削除
      if (name === 'a' && this.get(href, 'value', '') === '') return {}
      if (name === 'img' && this.get(src, 'value', '') === '') return {}
    }

    // 子要素を処理
    const child = object.childNodes
    if (child) object.childNodes = this.convert(child)

    return object
  }

  /**
   * attrs // 属性値をフィルタリング
   *
   * @param {array} array
   * @param {object} config
   *
   * @return {array}
   */
  attrs(array, config = {}) {
    if (!Array.isArray(array)) return array

    // アトリビュートの設定値を取得
    const arrowAttributes = this.get(config, 'attributes', [])

    const result = []
    array.forEach(item => {
      const isArrow = arrowAttributes.includes(item.name)
      if (isArrow) result.push(this.attrsCheck(item.name, item.value))
    })
    return result
  }

  attrsCheck(name, value) {
    return AttrsCheck.start(name, value)
  }

  /**
   * get 深い階層のObjectを取得する
   *
   * @param {object} object
   * @param {string} name
   * @param {any} defaultValue
   *
   * @return {any}
   */
  get(object, name, defaultValue) {
    return objectToGet(object, name, defaultValue)
  }

  /**
   * array // 配列データを処理
   *
   * @param {array} array
   *
   * @return {array}
   */
  array(array) {
    if (!Array.isArray(array)) return array

    const result = []
    array.forEach(item => {
      result.push(this.convert(item))
    })
    return result
  }
}

export default new SanitizeJs()
